import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import SeoMeta from "../../components/SeoMeta";
import PageTitle from "./components/PageTitle";
import PageBody from "./components/PageBody";
import Events from "./components/Events";
import AboutMeStructuredData from "./components/AboutMeStructuredData";
import { useLoading } from "../../contexts/LoadingContext";

const getLocale = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : 'en';
};

function Home() {
  const { t } = useTranslation();
  const { setIsLoading } = useLoading();
  const [aboutMe, setAboutMe] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";
  const STRAPI_TOKEN = process.env.REACT_APP_STRAPI_TOKEN;
  const locale = getLocale();

  useEffect(() => {
    const fetchData = async () => {
      if (!STRAPI_URL || !STRAPI_TOKEN) {
        console.error("Missing Strapi configuration");
        setError("Missing Strapi configuration");
        setLoading(false);
        return;
      }

      const url = `${STRAPI_URL}/api/about-me?locale=${locale}&populate[photo][populate]=*&populate[seo][populate]=*`;

      setIsLoading(true);
      try {
        const response = await fetch(url, {
          headers: {
            Authorization: `Bearer ${STRAPI_TOKEN}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const text = await response.text();
          throw new Error(`Fetch failed: ${response.status} - ${text}`);
        }

        const result = await response.json();
        setAboutMe(result.data);
      } catch (err) {
        console.error("❌ Fetch error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [STRAPI_URL, STRAPI_TOKEN, locale, setIsLoading]);

  const seo = aboutMe?.seo;

  return (
    <>
      <SeoMeta
        lang={locale}
        title={seo?.Title || aboutMe?.title || t("aboutMe.SeoTitle", "I'm Alberto")}
        description={seo?.Description || t("aboutMe.SeoDescription", "Italian living in Madrid. Passionate about photography, food and travel.")}
        keywords={seo?.keywords || t("aboutMe.SeoKeywords", "personal photography, analog inspiration, creative storytelling, tech-savvy lifestyle, visual curiosity, minimalist aesthetics, travel reflections, digital meets human, slow living moments, layered identity")}
        robots={seo?.robots || "index, follow"}
        imageUrl={seo?.image?.formats?.large?.url || seo?.image?.url}
      />
  
  
	  <AboutMeStructuredData
		description={aboutMe?.body?.map(block => block.children.map(child => child.text).join(" ")).join("\n")}
	  />

      <section className="py-15 py-xl-20">
        <PageTitle
		  title={t("aboutMe.title", "I'm Alberto")}
		  subtitle={t("aboutMe.subTitle", "Italian living in Madrid. Passionate about photography, food and travel.")}
		/>

        
  		
        <PageBody
          aboutMe={aboutMe}
          loading={loading}
          error={error}
        />

        <Events />
      </section>
    </>
  );
}

export default Home;
